import React, { useState, useEffect, useContext } from 'react';
import io from 'socket.io-client';

export const StoreContext = React.createContext();

export const StoreProvider = ({ children }) => {
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')));
  const [reload, setReload] = useState(0);
  const [socket, setSocket] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && !socket) {
      setSocket(io(process.env.SOCKET_URL, { withCredentials: true }));
    } else if (!user && socket) {
      socket.close();
      setSocket(null);
    }
  }, [user, socket]);

  return (
    <StoreContext.Provider
      value={{
        user,
        socket,
        reload,
        loading,
        setUser,
        setLoading,
        setReload: () => setReload(reload + 1),
      }}
    >
      {children}
    </StoreContext.Provider>
  );
};

export const withStore = Component => props => (
  <StoreContext.Consumer>
    {value => (
      <Component {...props} store={value} />
    )}
  </StoreContext.Consumer>
);

export const useStore = () => useContext(StoreContext);
